var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1632 7.40072C13.0982 7.40892 13.8628 6.65762 13.871 5.72264C13.8792 4.78766 13.1279 4.02306 12.1929 4.01485C11.258 4.00665 10.4934 4.75795 10.4851 5.69293C10.4769 6.62792 11.2282 7.39252 12.1632 7.40072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8995 23.2598C18.119 23.3144 23.2052 18.3167 23.2598 12.0972C23.3143 5.8777 18.3166 0.791548 12.0971 0.736983C5.87761 0.682417 0.791459 5.6801 0.736894 11.8996C0.682329 18.1191 5.68001 23.2053 11.8995 23.2598Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52553 7.46889C5.62449 7.1247 5.9826 6.92626 6.32536 7.02562L10.3824 8.20199C10.4282 8.21322 11.3812 8.44499 12.0136 8.45054C12.6618 8.45626 13.6913 8.20799 13.6913 8.20799V8.20803L17.6856 7.12571C18.03 7.03239 18.3846 7.23712 18.4775 7.58297C18.5705 7.92887 18.3666 8.28489 18.0222 8.37822L13.6795 9.55491L13.6439 13.6341L13.6435 13.634L15.5 18.7767C15.671 19.2503 15.4272 19.7735 14.9556 19.9451C14.4839 20.1168 13.9629 19.8721 13.792 19.3985L11.982 14.3848L10.0694 19.4062C9.89014 19.8767 9.36497 20.1123 8.8964 19.9323C8.42779 19.7523 8.19322 19.225 8.37248 18.7545L10.3339 13.6049H10.3334L10.3689 9.54838L5.96693 8.272C5.62416 8.17264 5.42654 7.81304 5.52553 7.46889Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibility);
export default __webpack_public_path__ + "static/media/accessibility.b596fc61b2864483692edc71afe539fa.svg";
export { ForwardRef as ReactComponent };